import am1Img from "../../assest/images/am-1.png";
import am2Img from "../../assest/images/am-2.png";
import am3Img from "../../assest/images/am-3.png";
import ToastAlert from "../../common/ToastAlert";
import { useState } from "react";

const MultiBanco = ({ mbResponse, isMBLoading, generateMultiBancoRefrence }) => {



    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const checkboxChangeHandler = () => {
        if (!isCheckboxChecked) {
            setIsCheckboxChecked(!isCheckboxChecked)
        }
    }
    const onClickContinue = async () => {
        if (!isCheckboxChecked) {
            ToastAlert({ msg: "Please check terms & condition", msgType: "error" });
            return false;
        }
        await generateMultiBancoRefrence();
    }

    return (
        <div className="registerBox amountDetail">
            {
                isMBLoading == false &&
                <>
                    <div className="checkAndGo">
                        <div className="tandcMainDiv">
                            <div className="clickTo" onClick={() => checkboxChangeHandler()}>
                                <input type="checkbox"
                                    checked={isCheckboxChecked}
                                    disabled={isCheckboxChecked}
                                    className="keyword-checkbox" />

                                <label htmlFor="" className="keyword-label" style={{ cursor: "pointer" }}>I have read and agree to the website </label>
                            </div>
                            <a target="_blank" className="tandcLink" href="/terms-and-conditions"> terms and conditions</a>
                        </div>
                    </div>

                    <div className="continueBox">
                        <button className="btn continueBtn"
                            onClick={() => onClickContinue()}
                        >Continue <i className="fa-solid fa-circle-arrow-right"></i></button>
                    </div>
                </>
            }
        </div>
    )

}
export default MultiBanco